/**
 * 模拟动物数据数组
 * 用于本地开发和测试
 */
const mockAnimals = [
  {
    id: "tiger-001",
    name: "Tiger",
    image: "https://images.unsplash.com/photo-1561731216-c3a4d99437d5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The tiger is the largest living cat species and a member of the genus Panthera. It is most recognisable for its dark vertical stripes on orange-brown fur with a lighter underside.",
    habitat: "Tropical rainforests, evergreen forests, temperate forests, mangrove swamps",
    diet: "Carnivore - mainly deer, wild boar, and buffalo",
    lifespan: "10-15 years in the wild, up to 20 in captivity"
  },
  {
    id: "elephant-002",
    name: "Elephant",
    image: "https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "Elephants are the largest existing land animals and are known for their intelligence, long memory, and complex social structures. They are characterized by their large, trunk-like nose.",
    habitat: "Forests, grasslands, marshes, and deserts",
    diet: "Herbivore - grass, leaves, bamboo, bark, roots, and fruits",
    lifespan: "60-70 years"
  },
  {
    id: "penguin-003",
    name: "Emperor Penguin",
    image: "https://images.unsplash.com/photo-1551986782-d0169b3f8fa7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The emperor penguin is the tallest and heaviest of all living penguin species and is endemic to Antarctica. Like all penguins, it is flightless, with a streamlined body and wings stiffened and flattened into flippers.",
    habitat: "Antarctic sea ice and waters",
    diet: "Carnivore - fish, krill, and squid",
    lifespan: "15-20 years in the wild"
  },
  {
    id: "fox-004",
    name: "Red Fox",
    image: "https://images.unsplash.com/photo-1516934024742-b461fba47600?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The red fox is the largest of the true foxes and one of the most widely distributed members of the order Carnivora. They have a reddish-orange coat, a white-tipped bushy tail, and black ears and legs.",
    habitat: "Forests, grasslands, mountains, and deserts",
    diet: "Omnivore - small mammals, birds, fruits, and insects",
    lifespan: "2-5 years in the wild, up to 14 in captivity"
  },
  {
    id: "owl-005",
    name: "Barn Owl",
    image: "https://images.unsplash.com/photo-1579591219018-364d9dbc746b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The barn owl is the most widely distributed species of owl in the world. It has a distinctive heart-shaped face and is known for its ghostly appearance and screeching calls.",
    habitat: "Open woodlands, farmland, and urban areas",
    diet: "Carnivore - primarily small mammals like mice, shrews, and voles",
    lifespan: "4-5 years in the wild"
  },
  {
    id: "panda-006",
    name: "Giant Panda",
    image: "https://images.unsplash.com/photo-1566487097168-e91a4f38bee2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The giant panda is a bear native to South Central China. It is characterised by its bold black-and-white coat and rotund body. Despite being a carnivore, the giant panda's diet is primarily herbivorous, consisting almost exclusively of bamboo.",
    habitat: "Temperate mountain forests of southwest China",
    diet: "Herbivore - primarily bamboo",
    lifespan: "15-20 years in the wild, up to 30 in captivity"
  },
  {
    id: "dolphin-007",
    name: "Bottlenose Dolphin",
    image: "https://images.unsplash.com/photo-1607153333879-c174d265f1d2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The bottlenose dolphin is one of the most well-known species of dolphin. They're highly intelligent marine mammals with a playful nature and are known for their curved mouth, giving the appearance of a friendly smile.",
    habitat: "Warm and temperate seas worldwide",
    diet: "Carnivore - mainly fish, squid, and crustaceans",
    lifespan: "40-60 years"
  },
  {
    id: "kangaroo-008",
    name: "Red Kangaroo",
    image: "https://images.unsplash.com/photo-1579268269047-8763e8031d40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The red kangaroo is the largest of all kangaroos, the largest terrestrial mammal native to Australia, and the largest extant marsupial. It is known for its powerful hind legs, large feet, and long muscular tail.",
    habitat: "Arid and semi-arid regions of Australia",
    diet: "Herbivore - grasses and flowering plants",
    lifespan: "12-17 years in the wild"
  },
  {
    id: "hummingbird-009",
    name: "Ruby-throated Hummingbird",
    image: "https://images.unsplash.com/photo-1552607676-17f088307dce?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The ruby-throated hummingbird is a species of hummingbird that generally spends the winter in Central America and migrates to Eastern North America for the summer to breed. They are known for their brilliant iridescent plumage.",
    habitat: "Open woodlands, forest edges, meadows, and gardens",
    diet: "Nectar from flowers, small insects, and spiders",
    lifespan: "3-5 years"
  },
  {
    id: "wolf-010",
    name: "Gray Wolf",
    image: "https://images.unsplash.com/photo-1564466809058-bf4114d55352?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
    description: "The gray wolf, also known as the timber wolf, is a canine native to the wilderness and remote areas of Eurasia and North America. It is the largest extant member of its family, with males averaging 43–45 kg and females 36–38.5 kg.",
    habitat: "Forests, tundra, mountains, grasslands, and deserts",
    diet: "Carnivore - large ungulates like deer, elk, and moose",
    lifespan: "6-8 years in the wild, up to 17 in captivity"
  }
];

export default mockAnimals; 